﻿import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UISprite} from "../Tools/Base/UISprite";
import {UIText} from "../Tools/Base/UIText";
import {Core} from "../../Base/Core";

export class UIMissionEmpty extends UICommonPopup {
    Awake() {
        super.Awake({
            title: Core.Localizator.Get("missions"),
            closeButton: true,
        });

        this.picture = this.content.addChild(new UISprite("rocket"));
        this.description = this.content.addChild(new UIText(Core.Localizator.Get("no_missions")));

        this.chooseBtn = this.content.addChild(new UINineSliceButton("btn-green", Core.Localizator.Get("choose")));
    }

    Init() {
        super.Init();
        this.chooseBtn.on("pointertap", () => {
            this.Hide();
            Core.UI.missionsList.Show();
        });
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.5;
        let w = Math.min(viewport.width * 0.9, (viewport.height * 0.8) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.width = contentRect.width * 0.7;
        rect.height = contentRect.height * 0.4;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.32;
        this.picture.fitRect(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.75;
        rect.height = contentRect.height * 0.11;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.72;
        this.description.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.6;
        rect.height = contentRect.height * 0.15;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.95;
        this.chooseBtn.fitLayout(rect);
    }

    Show() {
        Core.Player.PlanetsSave.TutorSave.missions = true;
        super.Show();
        if (Core.Player.PlanetsSave.TutorSave.step === 10) {
            Core.UI.tutorial.ShowObjectHand(this.chooseBtn);
        }
    }

    Hide() {
        Core.UI.tutorial.HideObjectHand(this.chooseBtn);
        super.Hide();
    }
}
